module.exports = __webpack_public_path__ + "img/pedale-seguranca.239744bf.jpg";